/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_MethodInputs */

const de__field_method = /** @type {(inputs: _Field_MethodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktart`)
};

/**

* @param {_Field_MethodInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_method = /** @type {((inputs?: _Field_MethodInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_MethodInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_method(inputs)
});